// Oyun sabitleri ve yardımcı fonksiyonlar

export const FIELD_COLOR = '#2d8a4e';
export const FIELD_COLOR_ALT = '#3a9a5c';
export const FIELD_LINE_COLOR = 'rgba(255,255,255,0.7)';
export const GOAL_COLOR = '#ffffff';
export const BALL_COLOR = '#ffffff';

// Oyun durumları
export const GAME_PHASE = {
  KICKOFF: 'kickoff',
  PLAYING: 'playing',
  GOAL_SCORED: 'goal_scored',
  GOAL_KICK: 'goal_kick',
  THROW_IN: 'throw_in',
  CORNER_KICK: 'corner_kick',
  FOUL: 'foul',
  HALF_TIME: 'half_time',
  SECOND_HALF_KICKOFF: 'second_half_kickoff',
  FULL_TIME: 'full_time',
  CELEBRATION: 'celebration',
};

// Maç süresi (saniye) - 2 devre x 3 dk
export const HALF_DURATION = 180;

// Fizik sabitleri
export const FRICTION = 0.97;
export const BALL_FRICTION = 0.985;
export const GRAVITY = 0.35;
export const BALL_RADIUS = 6;
export const PLAYER_RADIUS = 11;
export const PLAYER_SPEED = 3.8;
export const AI_SPEED = 3.0;
export const SPRINT_MULTIPLIER = 1.55;
export const PLAYER_ACCEL = 0.34;
export const PLAYER_DECEL = 0.22;
export const SHOOT_POWER = 14;
export const PASS_POWER = 7.5;
export const THROUGH_PASS_POWER = 10;
export const TACKLE_RANGE = 32;
export const MAX_SHOOT_POWER = 18;
export const MIN_SHOOT_POWER = 8;

// Saha kenar boşluğu (top ve oyuncular bu bölgede kalır)
export const FIELD_MARGIN = 8;

// Kale boyutları
export const GOAL_POST_WIDTH = 5;
export const GOAL_DEPTH = 35;

// Yardımcı fonksiyonlar
export function dist(x1, y1, x2, y2) {
  return Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
}

export function normalize(x, y) {
  const len = Math.sqrt(x * x + y * y);
  if (len === 0) return { x: 0, y: 0 };
  return { x: x / len, y: y / len };
}

export function clamp(val, min, max) {
  return Math.max(min, Math.min(max, val));
}

export function lerp(a, b, t) {
  return a + (b - a) * t;
}

export function randomRange(min, max) {
  return min + Math.random() * (max - min);
}

export function angle(x1, y1, x2, y2) {
  return Math.atan2(y2 - y1, x2 - x1);
}
